module.exports = __webpack_public_path__ + "static/media/forward_blue.08a33ee3.svg";